module.exports = __webpack_public_path__ + "img/twitter-icon-black.82555c02.svg";